import type { GlobalTranslations } from '../interfaces/global';

export const globalTranslations: GlobalTranslations = {
  input_error_invalid_email: 'Enter a valid email address.',
  input_error_required: 'This field is required',
  input_error_min_length: 'This field must be at least {{length}} characters',
  logout: 'Log out',
  input_error_phone_indicative_required: 'The indicative is required',
  input_error_phone_required: 'The phone number is required',
  input_error_phone_invalid:
    'The phone number format is invalid for the selected country',
  input_error_register_code:
    'The format must be xxxxxxxxxxxxxx== where x can be letters, numbers, and symbols.',
  input_error_not_terms: 'You must accept our terms and conditions',
  error_login_credentials: 'Check your username or password.',
  successful_deletion_message: 'Successfully deleted.',
  successful_disabled_message: 'Successfully disabled.',
  successful_active_message: 'Successfully activated.',
  successful_create_message: 'Successfully created.',
  successful_update_message: 'Successfully updated.',
  error_token_message:
    'An error occurred due to the non-existence or prior use of the token. Please generate a new token to continue.',
  input_date_placeholder: 'Pick a date',
  input_optional_label: '(optional)',
  input_show_password_label: 'Show password',
  input_hide_password_label: 'Hide password',
  input_search_placeholder: 'Search',
  input_phone_number_placeholder: 'Enter your phone number',
  input_phone_number_label: 'Phone number',
  not_found_message: 'No results found',
  input_phone_label: 'Phone',
  input_phone_placeholder: 'Enter the phone number',
  sidebar_settings_label: 'Settings',
  sidebar_customers_label: 'Customers',
  sidebar_chats_label: 'Chats',
  sidebar_reports_label: 'Reports',
  sidebar_agents_label: 'Agents',
  sidebar_products_label: 'Catalog',
  sidebar_templates_label: 'Templates',
  sidebar_groups_label: 'Groups',
  sidebar_meta_ads_label: 'Meta Ads',
  sidebar_account_label: 'My account',
  sidebar_organization_label: 'Organization',
  sidebar_group_main_label: 'Main',
  notifications_title: 'Notifications',
  notifications_empty_title: 'No notifications',
  pagination_records: 'Showing {{from}} to {{to}} of {{total}} results',
  pagination_empty: 'No results',
  pagination_prev_page: 'Previous page',
  pagination_next_page: 'Next page',
  app_error_title: 'Something went wrong',
  app_error_description:
    'We could not load this screen. The report is already with us and we are looking into it.',
  app_error_retry: 'Try again',
  impersonation_banner: 'Support session: you are viewing {{email}}’s account. Anything you change here changes for the customer.',
};
